import { Spin } from 'components';
import styles from './main.module.scss';
import { Box, Button, Modal } from '@mui/material';

type CustomModalProps = {
  open: boolean;
  text?: string;
  okText?: string;
  headerText?: string;
  click: Function;
  loading?: boolean;
  handleCancel: () => void;
};

const DeleteModal = ({
  click,
  open,
  text,
  okText,
  loading,
  headerText,
  handleCancel,
}: CustomModalProps) => {
  return (
    <Modal open={Boolean(open)} onClose={handleCancel}>
      <Box className={styles.modal}>
        <p className={styles.title}> {headerText ? headerText : 'Подтвердите удаление'}</p>
        <p className={styles.subtitle}>
          {text
            ? text
            : 'Вы уверенны что хотите удалить выбранный пункт? После удаления его нельзя будет восстановить.'}
        </p>

        <div className={styles.footer}>
          <Button className={styles.cancel} onClick={handleCancel}>
            Нет
          </Button>
          <Button className={styles.ok} onClick={() => click()} disabled={loading}>
            {loading && <Spin size='20px' />} <Box mr='10px' /> {okText ? okText : 'Удалить'}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default DeleteModal;
